export default __webpack_public_path__ + "static/media/xano-logo.9819a9d4.png";